// Claude 2026-09-24 · Owned reviews widget (progressive enhancement over server-rendered Liquid).
// 2026-10-24: review points copy from the email link, ?photos=1, add-a-photo-after step.
// Review text is always inserted as text nodes, never HTML. API: Supabase function bs-reviews.
const root = document.querySelector('[data-bsr]');
if (root) init(root);

function init(root) {
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const api = `${root.dataset.bsrApi.replace(/\/$/, '')}/bs-reviews`;
  const product = root.dataset.bsrProduct;
  const per = Number(root.dataset.bsrPer) || 8;
  const list = $('[data-bsr-list]'), more = $('[data-bsr-more]'), status = $('[data-bsr-status]'), reset = $('[data-bsr-reset]');
  const q = $('[data-bsr-q]'), photos = $('[data-bsr-photos]'), sort = $('[data-bsr-sort]');
  const state = { page: 1, rating: 0, total: Number(root.dataset.bsrTotal) || 0, shown: list.querySelectorAll('.bsr-card:not(.bsr-skeleton)').length };
  const url = new URL(location.href);
  let seq = 0;

  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const fmtDate = (iso) => { const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); };
  const filtered = () => !!(state.rating || photos.checked || q.value.trim() || sort.value !== 'recent');

  function card(r) {
    const a = el('article', 'bsr-card'); a.dataset.bsrId = r.id;
    const head = el('header', 'bsr-card-head');
    const stars = el('span', 'bsr-stars'); stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', `${r.rating} out of 5 stars`);
    const glyphs = el('span'); glyphs.setAttribute('aria-hidden', 'true');
    for (let i = 1; i <= 5; i++) glyphs.append(i <= r.rating ? '★' : el('i', null, '★'));
    stars.append(glyphs);
    const t = el('time', null, fmtDate(r.date)); t.dateTime = r.date;
    head.append(stars, t); a.append(head);
    if (r.title) a.append(el('h3', 'bsr-card-title', r.title));
    const body = el('p', 'bsr-card-body', r.body); a.append(body);
    if (r.body.length > 320) { body.classList.add('is-long'); const b = el('button', 'bsr-more-text', 'Read more'); b.type = 'button'; b.dataset.bsrExpand = ''; b.setAttribute('aria-expanded', 'false'); a.append(b); }
    if (r.photos?.length) {
      const wrap = el('div', 'bsr-card-photos');
      for (const p of r.photos.slice(0, 5)) {
        const b = el('button', 'bsr-photo'); b.type = 'button'; b.dataset.bsrPhoto = p.url; b.setAttribute('aria-label', `Open photo from ${r.author}`);
        const img = el('img'); img.src = p.thumb || p.url; img.alt = `Books shared by ${r.author}`; img.width = 84; img.height = 84; img.loading = 'lazy';
        b.append(img); wrap.append(b);
      }
      a.append(wrap);
    }
    const foot = el('footer', 'bsr-card-foot'); foot.append(el('b', null, r.author || 'Anonymous'));
    if (r.verified) foot.append(el('span', 'bsr-verified', '✓ Verified buyer'));
    a.append(foot);
    if (r.reply) { const rep = el('div', 'bsr-reply'); rep.append(el('b', null, 'Reply from TheBookScription'), el('p', null, r.reply)); a.append(rep); }
    return a;
  }

  function paintSummary(s) {
    if (!s) return;
    state.total = s.count;
    const pct = Math.max(0, Math.min(100, s.rating * 20));
    $('[data-bsr-avg]').textContent = s.count ? s.rating.toFixed(2) : '–';
    $('[data-bsr-avg-fill]').style.width = `${pct}%`;
    $('[data-bsr-count]').textContent = s.count;
    for (let i = 1; i <= 5; i++) {
      const n = s.histogram?.[i] ?? 0;
      $(`[data-bsr-n="${i}"]`).textContent = n;
      $(`[data-bsr-meter="${i}"]`).style.width = `${s.count ? (n / s.count) * 100 : 0}%`;
    }
    document.querySelectorAll('[data-bsr-badge-count]').forEach((n) => { n.textContent = s.count; });
    document.querySelectorAll('[data-bsr-badge-rating]').forEach((n) => { n.textContent = s.rating.toFixed(2); });
  }

  function paintStatus(total) {
    status.textContent = total ? `Showing ${Math.min(state.shown, total)} of ${total} ${total === 1 ? 'review' : 'reviews'}${state.rating ? ` · ${state.rating} star${state.rating > 1 ? 's' : ''}` : ''}${photos.checked ? ' · with photos' : ''}${q.value.trim() ? ' matching your search' : ''}` : '';
    more.hidden = state.shown >= total;
    more.textContent = `Show ${Math.min(per, Math.max(0, total - state.shown))} more reviews`;
    reset.hidden = !filtered();
    $$('[data-bsr-rating]').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.bsrRating) === state.rating)));
  }

  async function load({ append = false, withSummary = false } = {}) {
    const my = ++seq;
    const p = new URLSearchParams({ product, page: String(state.page), per: String(per), sort: sort.value });
    if (state.rating) p.set('rating', String(state.rating));
    if (photos.checked) p.set('photos', '1');
    if (q.value.trim()) p.set('q', q.value.trim());
    if (withSummary) p.set('summary', '1');
    more.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${api}?${p}`, { headers: { Accept: 'application/json' } });
      const d = await res.json();
      if (my !== seq) return;
      if (!res.ok) throw new Error(d.error || 'Reviews unavailable');
      if (withSummary) paintSummary(d.summary);
      if (!append) { list.replaceChildren(); state.shown = 0; }
      const first = list.children.length;
      for (const r of d.reviews) list.append(card(r));
      state.shown += d.reviews.length;
      if (!d.total) list.append(el('p', 'bsr-empty', filtered() ? 'No reviews match those filters. Try another word or clear your filters.' : 'No reviews yet. Be the first!'));
      paintStatus(d.total);
      if (append) { const f = list.children[first]; if (f) { f.tabIndex = -1; f.focus({ preventScroll: true }); } }
    } catch (e) {
      if (my === seq) status.textContent = 'Reviews couldn’t load right now. Please refresh to try again.';
    } finally { more.removeAttribute('aria-busy'); }
  }

  // Server-rendered first page: only fetch if the metafield was missing.
  if (root.dataset.bsrServer !== '1') load({ withSummary: true });
  else paintStatus(state.total);

  let timer;
  const refilter = () => { state.page = 1; load(); };
  q.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(refilter, 300); });
  photos.addEventListener('change', refilter);
  sort.addEventListener('change', refilter);
  $$('[data-bsr-rating]').forEach((b) => b.addEventListener('click', () => {
    const r = Number(b.dataset.bsrRating); state.rating = state.rating === r ? 0 : r; refilter();
    list.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }));
  reset.addEventListener('click', () => { q.value = ''; photos.checked = false; sort.value = 'recent'; state.rating = 0; refilter(); });
  more.addEventListener('click', () => { state.page = Math.floor(state.shown / per) + 1; load({ append: true }); });

  // Expand long reviews + photo lightbox (event delegation covers server- and JS-rendered cards).
  const box = $('[data-bsr-lightbox]'), boxImg = $('[data-bsr-lightbox-img]');
  root.addEventListener('click', (e) => {
    const x = e.target.closest('[data-bsr-expand]');
    if (x) { const b = x.previousElementSibling; const open = b.classList.toggle('is-open'); x.textContent = open ? 'Show less' : 'Read more'; x.setAttribute('aria-expanded', String(open)); return; }
    const ph = e.target.closest('[data-bsr-photo]');
    if (ph && box?.showModal) { boxImg.src = ph.dataset.bsrPhoto; boxImg.alt = ph.querySelector('img')?.alt || ''; box.showModal(); }
  });
  $('[data-bsr-lightbox-close]')?.addEventListener('click', () => box.close());
  box?.addEventListener('click', (e) => { if (e.target === box) box.close(); });

  // ---------- write a review ----------
  const form = $('[data-bsr-form]'), writeBtn = $('[data-bsr-write]'), thanks = $('[data-bsr-thanks]'), err = $('[data-bsr-form-error]');
  const files = $('[data-bsr-files]'), thumbs = $('[data-bsr-thumbs]'), submit = $('[data-bsr-submit]');
  const uploads = []; // { url|null, pending: Promise }
  const f = (n) => form.elements.namedItem(n); // form.name/form.title would return the form's own attributes
  let openedAt = 0, token = url.searchParams.get('review') || '', points = null;

  function openForm(focus = true) {
    form.hidden = false; thanks.hidden = true; writeBtn.setAttribute('aria-expanded', 'true'); openedAt = Date.now();
    form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (focus) (form.querySelector('input[name=rating]:checked') ? f('body') : form.querySelector('.bsr-pick-stars label:last-of-type'))?.focus?.({ preventScroll: true });
  }
  writeBtn.addEventListener('click', () => (form.hidden ? openForm() : (form.hidden = true, writeBtn.setAttribute('aria-expanded', 'false'))));
  $('[data-bsr-cancel]').addEventListener('click', () => { form.hidden = true; writeBtn.setAttribute('aria-expanded', 'false'); writeBtn.focus(); });

  // Email link: ?review=<token>&rating=N opens the form, pre-picks the stars, skips the email field.
  if (token) {
    const star = Number(url.searchParams.get('rating'));
    if (star >= 1 && star <= 5) { const r = form.querySelector(`input[name=rating][value="${star}"]`); if (r) r.checked = true; }
    $('[data-bsr-email-field]').hidden = true; f('email').required = false;
    openForm(false);
    fetch(`${api}?request=${encodeURIComponent(token)}`).then((r) => r.json()).then((d) => {
      if (!d.ok) { token = ''; $('[data-bsr-email-field]').hidden = false; f('email').required = true; $('[data-bsr-form-intro]').textContent = d.error || 'Good or bad, we publish every genuine review.'; return; }
      if (d.firstName) { f('name').value = f('name').value || d.firstName; $('[data-bsr-form-title]').textContent = `Hi ${d.firstName}, how was your box?`; }
      points = d.points || null;
      if (points) {
        $('[data-bsr-form-intro]').textContent = `Your review earns ${points.review.toLocaleString()} points${points.photo ? `, plus ${points.photo} more with a photo` : ''}. Same points for every honest review, 1 star or 5.`;
        if (points.photo) { const pp = $('[data-bsr-photo-points]'); pp.textContent = `+${points.photo} points`; pp.hidden = false; }
      }
      if (d.alreadyReviewed) {
        $('[data-bsr-form-intro]').textContent = 'You already reviewed this box. Thank you! You can add another review if you like.';
        // ?photos=1 after the review exists: go straight to the add-a-photo step.
        if (url.searchParams.get('photos') === '1' && !d.photos) { form.hidden = true; showAddPhoto(''); }
      } else if (url.searchParams.get('photos') === '1') $('[data-bsr-files]').closest('.bsr-field')?.scrollIntoView({ block: 'center' });
    }).catch(() => {});
  }

  async function shrink(file) {
    // Resize to 1600px max and re-encode (strips location metadata from phone photos).
    const bmp = await createImageBitmap(file).catch(() => null);
    if (!bmp) return null;
    const scale = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
    const c = document.createElement('canvas'); c.width = Math.round(bmp.width * scale); c.height = Math.round(bmp.height * scale);
    c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
    let blob = await new Promise((r) => c.toBlob(r, 'image/webp', 0.85));
    if (!blob || blob.type !== 'image/webp') blob = await new Promise((r) => c.toBlob(r, 'image/jpeg', 0.86));
    return blob;
  }
  files.addEventListener('change', async () => {
    for (const f of [...files.files].slice(0, 5 - uploads.length)) {
      const fig = el('figure'); fig.dataset.state = 'uploading';
      const img = el('img'); img.alt = ''; img.src = URL.createObjectURL(f); fig.append(img);
      const x = el('button', null, '×'); x.type = 'button'; x.setAttribute('aria-label', 'Remove photo'); fig.append(x);
      thumbs.append(fig);
      const item = { url: null };
      item.pending = (async () => {
        const blob = await shrink(f);
        if (!blob) throw new Error('That photo type isn’t supported. Try a JPG or PNG.');
        const res = await fetch(`${api}?upload=1`, { method: 'POST', headers: { 'Content-Type': blob.type }, body: blob });
        const d = await res.json();
        if (!res.ok) throw new Error(d.error || 'Photo upload failed');
        item.url = d.url; fig.dataset.state = 'done';
      })().catch((e) => { fig.remove(); uploads.splice(uploads.indexOf(item), 1); showError(e.message); });
      x.addEventListener('click', () => { fig.remove(); const i = uploads.indexOf(item); if (i > -1) uploads.splice(i, 1); });
      uploads.push(item);
    }
    files.value = '';
  });

  function showError(m) { err.textContent = m; err.hidden = false; }

  // ---------- add a photo after the review (email-link reviewers) ----------
  const ap = $('[data-bsr-addphoto]'), apFiles = $('[data-bsr-addphoto-files]'), apThumbs = $('[data-bsr-addphoto-thumbs]');
  const apSave = $('[data-bsr-addphoto-save]'), apErr = $('[data-bsr-addphoto-error]'), apUploads = [];
  function showAddPhoto(message) {
    thanks.hidden = false; ap.hidden = false;
    if (message) $('[data-bsr-thanks-text]').textContent = message;
    else $('[data-bsr-thanks-text]').textContent = 'Your review is in.';
    $('[data-bsr-addphoto-head]').textContent = points?.photo ? `Add a photo of your books and earn ${points.photo} more points` : 'Add a photo of your books';
    thanks.focus();
  }
  apFiles.addEventListener('change', () => {
    for (const file of [...apFiles.files].slice(0, 5 - apUploads.length)) {
      const fig = el('figure'); fig.dataset.state = 'uploading';
      const img = el('img'); img.alt = ''; img.src = URL.createObjectURL(file); fig.append(img); apThumbs.append(fig);
      const item = { url: null };
      item.pending = (async () => {
        const blob = await shrink(file);
        if (!blob) throw new Error('That photo type isn’t supported. Try a JPG or PNG.');
        const res = await fetch(`${api}?upload=1`, { method: 'POST', headers: { 'Content-Type': blob.type }, body: blob });
        const d = await res.json();
        if (!res.ok) throw new Error(d.error || 'Photo upload failed');
        item.url = d.url; fig.dataset.state = 'done';
      })().catch((e) => { fig.remove(); apUploads.splice(apUploads.indexOf(item), 1); apErr.textContent = e.message; apErr.hidden = false; });
      apUploads.push(item);
    }
    apFiles.value = ''; apSave.hidden = !apUploads.length;
  });
  apSave.addEventListener('click', async () => {
    apErr.hidden = true; apSave.disabled = true; apSave.textContent = 'Adding…';
    try {
      await Promise.all(apUploads.map((u) => u.pending));
      const res = await fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ add_photos: true, token, photos: apUploads.map((u) => u.url).filter(Boolean) }) });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || 'Something went wrong. Please try again.');
      ap.hidden = true;
      $('[data-bsr-thanks-text]').textContent = points?.photo ? `Photo added. Thank you! Your ${points.photo} bonus points show up in your account soon.` : 'Photo added. Thank you!';
      state.page = 1; load({ withSummary: true });
    } catch (e) { apErr.textContent = e.message; apErr.hidden = false; }
    finally { apSave.disabled = false; apSave.textContent = 'Add to my review'; }
  });
  form.addEventListener('submit', async (e) => {
    e.preventDefault(); err.hidden = true;
    const rating = Number(form.querySelector('input[name=rating]:checked')?.value);
    if (!rating) return showError('Pick a star rating first.');
    if (f('body').value.trim().length < 2) return showError('Tell us a little about your box.');
    if (!f('name').value.trim()) return showError('Add your first name (or tick “Post as Anonymous”).');
    if (!token && !/^\S+@\S+\.\S+$/.test(f('email').value.trim())) return showError('Add your email so we know you’re a real reader. We never show it.');
    submit.setAttribute('aria-busy', 'true'); submit.disabled = true; submit.textContent = 'Posting…';
    try {
      await Promise.all(uploads.map((u) => u.pending));
      const res = await fetch(api, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product, rating, title: f('title').value, body: f('body').value, name: f('name').value, email: f('email').value,
          anonymous: f('anonymous').checked, token: token || undefined, photos: uploads.map((u) => u.url).filter(Boolean),
          company: f('company').value, elapsed: Date.now() - openedAt,
        }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || 'Something went wrong. Please try again.');
      const hadPhotos = uploads.some((u) => u.url);
      form.hidden = true; form.reset(); thumbs.replaceChildren(); uploads.length = 0;
      thanks.hidden = false; $('[data-bsr-thanks-text]').textContent = d.message; thanks.focus();
      if (token && !hadPhotos) showAddPhoto(d.message);
      writeBtn.setAttribute('aria-expanded', 'false');
      if (d.status === 'published') { state.page = 1; load({ withSummary: true }); }
      document.dispatchEvent(new CustomEvent('bookscription:review', { detail: { rating, status: d.status } }));
    } catch (e2) { showError(e2.message); }
    finally { submit.removeAttribute('aria-busy'); submit.disabled = false; submit.textContent = 'Post my review'; }
  });
}
